import { Store } from '@ngrx/store';
import { changeSearchTypes } from 'SearchAllApp/state/search-all-params/search-all-params.actions';
import { getSearchTypes } from 'SearchAllApp/state/search-all.selectors';
import { SEARCH_ALL_METHODS } from 'SearchApp/ts/constants';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common";
import * as i3 from "@angular/forms";
function SearchAllCategoriesComponent_label_5_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 5)(1, "input", 6);
    i0.ɵɵtwoWayListener("ngModelChange", function SearchAllCategoriesComponent_label_5_Template_input_ngModelChange_1_listener($event) { const searchType_r2 = i0.ɵɵrestoreView(_r1).$implicit; i0.ɵɵtwoWayBindingSet(searchType_r2.checked, $event) || (searchType_r2.checked = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function SearchAllCategoriesComponent_label_5_Template_input_ngModelChange_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.changeSearchType()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 7);
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const searchType_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", searchType_r2.checked);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", searchType_r2.label, " ");
} }
/**
 *
 * SearchAllCategoriesComponent.
 *
 * This component is the filter by categories checkboxes.
 */
export class SearchAllCategoriesComponent {
    constructor(store) {
        this.store = store;
        this.searchTypes = [];
        this.mapStateToComponent = (state) => {
            const activeCategories = getSearchTypes(state);
            this.searchTypes = SEARCH_ALL_METHODS.map((searchType) => ({
                ...searchType,
                checked: activeCategories.includes(searchType.searchMethod),
            }));
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    /**
     * Dispatches `changeSearchTypes` to set the new values for `searchTypes`.
     */
    changeSearchType() {
        const searchTypes = this.searchTypes.filter(({ checked }) => checked).map(({ searchMethod }) => searchMethod);
        this.store.dispatch(changeSearchTypes({ searchTypes }));
    }
}
SearchAllCategoriesComponent.ɵfac = function SearchAllCategoriesComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SearchAllCategoriesComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
SearchAllCategoriesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SearchAllCategoriesComponent, selectors: [["ycn-search-all-categories"]], standalone: false, decls: 6, vars: 1, consts: [[1, "panel-sidebar-section-body"], [1, "form-row"], [1, "form-label", "form-label-thin", "pb-1"], [1, "custom-controls-stacked"], ["class", "custom-control custom-checkbox", 4, "ngFor", "ngForOf"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"]], template: function SearchAllCategoriesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtext(3, "Security Type");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, SearchAllCategoriesComponent_label_5_Template, 5, 2, "label", 4);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.searchTypes);
    } }, dependencies: [i2.NgForOf, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgModel], encapsulation: 2 });
